// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"footer_wrapper__1eqdC","text":"footer_text__3nbH8","email":"footer_email__1Tx6o"};